import { makeRequest } from "./makeRequest";

export function listLogs(params) {
  return makeRequest(`/v1/audit-logs`, "GET", null, { params });
}
